import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select } from "rbx";

import { ALL_ITEM_CATEGORIES_QUERY } from "../../graphql/ItemCategories/ItemCategories.graphql";

const ItemCategorySelect = ({
  value,
  label,
  size,
  name,
  onChange,
  required,
  readOnly,
  where
}) => {
  const { data, loading, error } = useQuery(ALL_ITEM_CATEGORIES_QUERY, {
    variables: {
      where
    },
    fetchPolicy: "network-only"
  });
  return (
    <Field>
      <Control size={size}>
        <Label size={size}>{label}</Label>
        <Select.Container
          fullwidth
          color={
            error ||
            (required &&
              (!value || value === "" || value === "0" || value === 0))
              ? "danger"
              : ""
          }
          size={size}
          state={loading || !data ? "loading" : null}
        >
          <Select
            disabled={readOnly}
            name={name}
            pattern="0"
            required={required}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="0">{label}</Select.Option>
            {!loading &&
              data.ItemCategorys.map((item, i) => (
                <Select.Option
                  key={`item-category-select-${i}`}
                  value={item.RecId}
                >
                  {item.Description}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
      </Control>
    </Field>
  );
};

ItemCategorySelect.propTypes = {
  value: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  where: PropTypes.object
};
export default ItemCategorySelect;
